import { default_dashboard } from '@core/breadcrumbs';

const module_mailer = default_dashboard.extend('mailer').add('mailer.breadcrumb.title', {
  name: 'mailer.mailing.index'
});
const mailer_items = ['mailing.create', 'sender.index'];
const mailer_breadcrumbs = mailer_items.map(item => {
  return module_mailer.extend(`mailer.${item}`).add(`mailer.breadcrumb.${item}`, {
    name: `mailer.mailing.${item}`
  });
});

const type_breadcrumbs = module_mailer
  .extend('mailer.mailing.type')
  .add('mailer.breadcrumb.mailing.index', {
    name: `mailer.mailing.index`
  });

mailer_breadcrumbs.push(type_breadcrumbs);

const stats_type_breadcrumbs = module_mailer
  .extend('mailer.stats.type')
  .add('shared.breadcrumb.stats.title', {
    name: `mailer.stats.index`
  });
mailer_breadcrumbs.push(stats_type_breadcrumbs);


const module_messages = module_mailer
  .extend('mailer_messages')
  .add('mailer.breadcrumb.message.title', {
    name: 'mailer.message.index'
  });
const mailer_messages_items = ['message.index', 'message.setting'];
const mailer_messages_beadcrumbs = mailer_messages_items.map(item => {
  return module_messages.extend(`mailer.${item}`).add(`mailer.breadcrumb.${item}`, {
    name: `mailer.mailing.${item}`
  });
});

export { mailer_breadcrumbs, mailer_messages_beadcrumbs };
